<template>
    <div class="music-box">
        <div class="music-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="music-box-common music-box-infor">
                <h3>专业介绍</h3>
                <p>音乐类艺术专业的突出特点就是要求学生具备一定的音乐方面的艺术特长天赋，并且训练的周期相对较长，特别是乐器，有时要付出多年的辛苦练习。因此专业学习的经济投入相对较大。<br>方向主要包括音乐表演、音乐学、音乐学(师范类)、作曲与作曲技术理论、音乐表演(指挥、演唱、乐器演奏)、录音艺术专业等对音乐基础、基本技能进行考察的技能类专业。</p>
            </div>
        </div> 
        <div class="music-box-work music-box-common music-box-common1">
            <h3>就业方向</h3>
            <el-row type="flex" class="music-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-tiao music-box-common music-box-common1">
            <h3>报考条件</h3>
            <el-row class="music-box-tiao-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-test music-box-common music-box-common1">
            <h3>考试内容</h3>
            <h4>音乐艺考生的考试内容一般包括音乐教育和器乐等</h4>
            <el-row class="music-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-subject music-box-common music-box-common1">
            <h3>学习科目</h3>
            <h4>声乐演唱、乐器演奏、乐理、视唱练耳</h4>
            <el-row class="music-box-subject-content">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-tips music-box-common music-box-common1">
            <h3>考试流程</h3>
            <el-row class="music-box-tips-content" type="flex" justify="space-between">
                <el-col class="music-box-tips-item1">
                    <div>音乐类专业考试形式分为初试、复试。<br>初试有面试、笔试和表演，基本常识、基本乐理,演唱演奏达到基本要求;复试往往在初试基础上,还有口试和听音笔试,不仅有规定项目,还有自选项目,注重表演技能和综合素质。<br>音乐专业考试科目为四门,即专业主科,包括声乐、器乐、舞蹈、作曲,同学们可任选其一,还有试唱、音乐基础知识、听音记谱等。<br>另外,专业主科选考声乐的同学,可加试器乐或舞蹈;专业主科选考器乐或舞蹈的同学,必须加试声乐;专业主科选考作曲的同学,必须加试器乐。<br>专业主科选考作曲的同学,如兼报师范类音乐教育专业,还必须加试声乐且成绩合格。</div>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-school music-box-common music-box-common1">
            <h3>推荐院校</h3>
            <el-row class="music-box-school-content">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <img :src="item.src" alt="">
                    <span>{{item.desc}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="music-box-order" id="add">
            <div class="music-box-order-content music-box-common music-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/music-work-icon1.png'),desc:'电台编辑'},
                {src:require('../../assets/images/music-work-icon2.png'),desc:'评论'},
                {src:require('../../assets/images/music-work-icon3.png'),desc:'策划'},
                {src:require('../../assets/images/music-work-icon4.png'),desc:'管理'},
                {src:require('../../assets/images/music-work-icon5.png'),desc:'影视公司'},
                {src:require('../../assets/images/music-work-icon6.png'),desc:'音乐教师'},
                {src:require('../../assets/images/music-work-icon7.png'),desc:'音乐策划人'},
                {src:require('../../assets/images/music-work-icon8.png'),desc:'音乐监制'},
                {src:require('../../assets/images/music-work-icon9.png'),desc:'音乐编辑'},
                {src:require('../../assets/images/music-work-icon10.png'),desc:'音乐经纪人'},
                {src:require('../../assets/images/music-work-icon11.png'),desc:'音乐制作人'},
                {src:require('../../assets/images/music-work-icon12.png'),desc:'音乐制片人'},
                {src:require('../../assets/images/music-work-icon13.png'),desc:'作曲'},
                {src:require('../../assets/images/music-work-icon14.png'),desc:'教师'},
                {src:require('../../assets/images/music-work-icon15.png'),desc:'乐团编曲'},
                {src:require('../../assets/images/music-work-icon16.png'),desc:'艺术管理'},
                {src:require('../../assets/images/music-work-icon17.png'),desc:'歌手'},
            ],
            tiaoList:[
                {src:require('../../assets/images/art-tiao-icon2.png'),desc:'无口吃，无色盲、色弱'},
                {src:require('../../assets/images/broadcast-tiao-icon1.png'),desc:'年龄在25周岁以下的未婚青年可以报考表演、演奏专业'},
                {src:require('../../assets/images/broadcast-tiao-icon3.png'),desc:'报考作曲专业的考生年龄可放宽到30周岁，婚否不限'},
            ],
            testList:[
                {src:require('../../assets/images/music-test-icon1.png'),desc:'主科(相关器乐择其一)'},
                {src:require('../../assets/images/music-test-icon2.png'),desc:'声乐'},
                {src:require('../../assets/images/music-test-icon3.png'),desc:'视唱练耳'},
                {src:require('../../assets/images/music-test-icon4.png'),desc:'音乐知识'},
                {src:require('../../assets/images/music-test-icon5.png'),desc:'写作'},
                {src:require('../../assets/images/music-test-icon6.png'),desc:'音乐综合素质面试'},
                {src:require('../../assets/images/music-test-icon7.png'),desc:'文化综合素质'},
                {src:require('../../assets/images/music-test-icon8.png'),desc:'副科'},
                {src:require('../../assets/images/music-test-icon9.png'),desc:'乐理'},
                {src:require('../../assets/images/music-test-icon10.png'),desc:'音乐常识及作品听辨'},
            ],
            subjectList:[
                {src:require('../../assets/images/music-subject-icon1.png'),desc:'试唱'},
                {src:require('../../assets/images/music-subject-icon2.png'),desc:'练耳'},
                {src:require('../../assets/images/music-subject-icon3.png'),desc:'声乐'},
                {src:require('../../assets/images/music-subject-icon4.png'),desc:'钢琴'},
                {src:require('../../assets/images/music-subject-icon5.png'),desc:'器乐'},
                {src:require('../../assets/images/music-subject-icon6.png'),desc:'乐谱'},
                {src:require('../../assets/images/music-subject-icon7.png'),desc:'音乐知识'},
                {src:require('../../assets/images/music-subject-icon8.png'),desc:'视频资料'},
                {src:require('../../assets/images/music-subject-icon9.png'),desc:'作曲'},
                {src:require('../../assets/images/music-subject-icon10.png'),desc:'音乐教育'},
            ],
            schoolList:[
                {src:require('../../assets/images/music-school-icon1.png'),desc:'中央音乐学院'},
                {src:require('../../assets/images/music-school-icon2.png'),desc:'中国音乐学院'},
                {src:require('../../assets/images/music-school-icon3.png'),desc:'上海音乐学院'},
                {src:require('../../assets/images/music-school-icon4.png'),desc:'四川音乐学院'},
                {src:require('../../assets/images/music-school-icon5.png'),desc:'武汉音乐学院'},
                {src:require('../../assets/images/music-school-icon6.png'),desc:'星海音乐学院'},
                {src:require('../../assets/images/director-school-icon8.jpg'),desc:'四川大学'},
                {src:require('../../assets/images/performance-school-icon5.png'),desc:'武汉大学'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '14'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.music-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.music-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 24px;
        margin: 27px 0 52px 0;
    }
}
.music-box-bg {
    background: url('../../assets/images/music-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.music-box-infor {
    width: $width;
    margin: $margin;
    height: 323px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.music-box-work {
    padding-top: 180px;
    height: 700px;
    background: #f5f7fa;
    box-sizing: border-box;
    .music-box-work-list {
        width: $width;
        margin: $margin;
        margin-top: 56px;
        // align-content:space-between;
        // flex-flow: row wrap;
        flex-wrap: wrap;
    }
    .el-col:not(:nth-child(9n)) {
        margin-right: 20px;
    }
    .el-col {
        width: 115px;
        text-align: center;
        h5 {
            margin-top: 16px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
            margin-bottom: 32px;
        }
    }
}
.music-box-tiao {
    height: 583px;
    background: url('../../assets/images/broadcast-tiao-bg.jpg') no-repeat center;
    background-size: cover;
    position: relative;
    padding-top: 52px;
    h3 {
        color: #ffffff;
    }
    .music-box-tiao-content {
        width: $width;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 376px;
            position: relative;
        }
        img {
            width: 376px;
            height: 228px;
        }
        h5 {
            // padding: 0 30px;
            margin: 0;
            font-size: 18px;
            font-family: $font-family;
            font-weight: 400;
            color: #ffffff;
            line-height: 32px;
            width: 100%;
            margin-top: 22px;
        }
    }
}
.music-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 754px;
    .music-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 224px;
            h5 {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #332e2c;
                margin: 20px 0 32px 0;
            }
        }
    }
}
.music-box-subject {
    width: 100%;
    height: 600px;
    background: #00b687;
    h3 {
        color: #fff;
    }
    h4 {
        color: rgba(255,255,255,0.60);
        margin-bottom: 56px;
    }
    .music-box-subject-content {
        width: $width;
        margin: $margin;
        margin-top: 56px;
        .el-col {
            width: 20%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.music-box-tips {
    width: 100%;
    height: 517px;
    background: #ffff;
    .music-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 56px;
        flex-wrap: wrap;
        .el-col {
            height: 280px;
            border-radius: 8px;
            padding: 32px;
            box-sizing: border-box; 
            margin-bottom: 24px;
            div {
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                line-height: 36px;
            }
        }
        .music-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
            h4 {
                color: #398cff;
            }
        }
    }
}
.music-box-school {
    height: 443px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .music-box-school-content {
        width: $width;
        margin: $margin;
        .el-col {
            padding: 16px 12px;
            width: 265px;
            height: 88px;
            box-sizing: border-box;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            span {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                top: -18px;
                left: 12px;
            }
        }
        .el-col:not(:nth-child(4n)) {
            margin-right: 46px;
        }
    }
}
.music-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color:#00b687;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        margin-bottom: 55px;
        color: rgba(255,255,255,0.60);
    }
    .music-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .music-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .music-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>